import React from 'react'
import { Button, Grid, Header } from 'semantic-ui-react'

class AQSelector extends React.Component<any, any> {

  render() {
    return (
      <React.Fragment>

        <Header as='h3' textAlign='center'>
          The next step is to provide information about your employment at Boots...
        </Header>

        <Header as='h4' textAlign='center'>
          We need information about your employment to bring your claim.
        </Header>

        <Header as='h4' textAlign='center'>
          You can provide information by uploading a payslip or answering a questionnaire. What would you like to do?
        </Header>

        <Grid columns='equal'>
          <Grid.Row>
            <Grid.Column>
              <Button
                fluid
                color='green'
                onClick={
                  () => {
                    this.props.gaEvent('event', 'FurtherInfoPaySlip', 'OptForPaySlip', 'Boots', this.props.isValid);
                    this.props.setFieldValue('aq_type', 'Payslip');
                    this.props.manualStep('PAYSLIP')
                  }
                }
                data-testid="aq-selector-button-payslip"
              >
                Upload Payslip
              </Button>

            </Grid.Column>
            <Grid.Column>
              <Button
                fluid
                color='green'
                onClick={
                  () => {
                    this.props.gaEvent('event', 'FurtherInfoQuestionnaire', 'OptForQuestionnaire', 'Boots', this.props.isValid);
                    this.props.setFieldValue('aq_type', 'Questionnaire');
                    this.props.manualStep('QUESTIONNAIRE')
                  }
                }
                data-testid="aq-selector-button-questionnaire"
              >
                Answer Questionnaire
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>

      </React.Fragment>
    )
  }
}

export default AQSelector;